import { Wrench, ShieldCheck, RefreshCw, FileText, ClipboardList } from 'lucide-react';

/**
 * The storefront's service pages, once (header links, footer column, account
 * shortcuts and the phone tab bar). Each place reads its own label; a page behind
 * a store feature that is off (D101) is left out through `canVisit` (StorefrontContext).
 * Warranty is always on, so the tab bar always has a services page.
 *
 *   places  where it is linked: header, footer, account, tab
 *   short   tab label · nav header label · long footer label · title/sub account tile
 */
export const SERVICE_PAGES = [
  { href: '/repair', places: ['header', 'footer', 'account', 'tab'], short: 'Repair', nav: 'Repair', long: 'Book a repair', title: 'Book a repair', sub: 'Pickup or drop-off', Icon: Wrench },
  // Always shown: with repairs off (D101) a shopper still finishes the repairs they have.
  { href: '/account/repairs', places: ['account'], title: 'My repairs', sub: 'Track, approve and pay', Icon: ClipboardList },
  { href: '/warranty', places: ['header', 'footer', 'account', 'tab'], short: 'Warranty', nav: 'Warranty', long: 'Warranty and claims', title: 'Warranty', sub: 'Coverage and claims', Icon: ShieldCheck },
  { href: '/sell', places: ['header', 'footer', 'account'], nav: 'Sell your device', long: 'Sell or exchange', title: 'Sell or exchange', sub: 'Get a provisional value', Icon: RefreshCw },
  { href: '/quote', places: ['footer'], long: 'Bulk & business quotes', Icon: FileText },
];

/** The service pages linked at `place` that this shopper may visit, in order. */
export const servicePages = (place, canVisit = () => true) => SERVICE_PAGES.filter((p) => p.places.includes(place) && canVisit(p.href));
